import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";

import NavigationBarGeneral from "../components/navigation-bar-general";
import Footer from "../components/footer";
import "./page.css";

const Page = (props) => {
  return (
    <div className="page-container">
      <Helmet>
        <title>404 | CashOver Pay</title>

        <meta
          name="description"
          content="Oops! The page you're looking for doesn't exist. Explore CashOver — your all‑in‑one digital wallet to send, receive, deposit, or withdraw money securely."
        />

        <meta property="og:title" content="404 Page Not Found | CashOver Pay" />
        <meta
          property="og:description"
          content="This page doesn’t exist. Discover CashOver’s secure digital wallet for individuals, merchants, and businesses."
        />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SITE_URL}/icon.webp`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cashover.money/404" />
      </Helmet>

      <NavigationBarGeneral
        text={
          <Fragment>
            <span className="page-text1">CASHOVER</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="page-text2">by overlab.io</span>
          </Fragment>
        }
        rootClassName="navigation-bar-generalroot-class-name"
      ></NavigationBarGeneral>
      <div className="page-column">
        <span className="page-text3">404</span>
        <div className="page-row">
          <svg viewBox="0 0 1024 1024" className="page-icon1">
            <path d="M64 0h384v64h-384zM576 0h384v64h-384zM952 320h-56v-256h-256v256h-256v-256h-256v256h-56c-39.6 0-72 32.4-72 72v560c0 39.6 32.4 72 72 72h304c39.6 0 72-32.4 72-72v-376h128v376c0 39.6 32.4 72 72 72h304c39.6 0 72-32.4 72-72v-560c0-39.6-32.4-72-72-72zM348 960h-248c-19.8 0-36-14.4-36-32s16.2-32 36-32h248c19.8 0 36 14.4 36 32s-16.2 32-36 32zM544 512h-64c-17.6 0-32-14.4-32-32s14.4-32 32-32h64c17.6 0 32 14.4 32 32s-14.4 32-32 32zM924 960h-248c-19.8 0-36-14.4-36-32s16.2-32 36-32h248c19.8 0 36 14.4 36 32s-16.2 32-36 32z"></path>
          </svg>
          <span className="page-text4">
            Looks Like this page doesn&apos;t exist
          </span>
        </div>
        <span className="page-text5">Go back Home and continue exploring</span>
        <Link to="/" className="page-navlink buttonFilled">
          Home
        </Link>
      </div>
      <Footer rootClassName="footerroot-class-name5"></Footer>
    </div>
  );
};

export default Page;
